module.exports = __webpack_public_path__ + "img/icons8-one-page-0.0041cd89.svg";